import { createStore } from 'vuex';
import tarifrechner from '@/store/tarifrechner';

interface APIRequest {
  method: 'get' | 'delete' | 'post' | 'put' | 'patch';
  url: string;
  data?: any;
  config?: any;
}

export default createStore({
  modules: {
    tarifrechner,
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
